import { useState } from "react";
import { Gym } from "../types";

export const useGymState = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [gymName, setGymName] = useState("");
  const [gymAddress, setGymAddress] = useState("");
  const [selectedGym, setSelectedGym] = useState<Gym | null>(null);

  const setSelectedGymAndUpdateStates = (gym: Gym | null) => {
    setSelectedGym(gym);
    if (gym) {
      console.log("Setting gym data:", gym);
      setGymName(gym.name);
      setGymAddress(gym.address);
    } else {
      setGymName("");
      setGymAddress("");
    }
  };

  return {
    isEditing,
    setIsEditing,
    gymName,
    setGymName,
    gymAddress,
    setGymAddress,
    selectedGym,
    setSelectedGym: setSelectedGymAndUpdateStates,
  };
};